module.exports = __webpack_public_path__ + "static/img/67.73a0019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/67.jpg
// module id = hxwj
// module chunks = 0